<template>
  <div class="loginContent">
    <div class="top"></div>
    <van-tabs
      v-model="active"
      @change="change"
      color="#FFA624"
      background="#F8F8F8"
      v-if="isLogin == 0"
    >
      <van-tab title="手机快捷登录">
        <div class="content">
          <div class="srk">
            <div class="phone">
              <img src="../../assets/images/loginphone.png" alt="" />
              <input type="number" v-model="phone" placeholder="请输入手机号" />
            </div>
          </div>
          <div class="srk">
            <div class="phone">
              <img src="../../assets/images/yzc.png" alt="" />
              <input type="number" v-model="code" placeholder="请输入验证码" />
              <p @click="sendCode">{{ codeBtn }}</p>
            </div>
          </div>
          <div class="btn" @click="codeLogin">登录</div>
          <div class="other">
            <p
              @click="
                $router.push({
                  path: '/register',
                })
              "
            >
              注册账号
            </p>
            <span>|</span>
            <p
              @click="
                $router.push({
                  path: '/forgetPassword',
                })
              "
            >
              忘记密码
            </p>
          </div>
        </div>
      </van-tab>
      <van-tab title="帐号密码登录"
        ><div class="content">
          <div class="srk">
            <div class="phone">
              <img src="../../assets/images/loginphone.png" alt="" />
              <input v-model="account" type="text" placeholder="请输入账号" />
            </div>
          </div>
          <div class="srk">
            <div class="phone">
              <img src="../../assets/images/password.png" alt="" />
              <input
                v-model="password"
                type="password"
                placeholder="请输入密码"
              />
            </div>
          </div>
          <div class="btn" @click="accountLogin">登录</div>
          <div class="other">
            <p
              @click="
                $router.push({
                  path: '/register',
                })
              "
            >
              注册账号
            </p>
            <span>|</span>
            <p
              @click="
                $router.push({
                  path: '/forgetPassword',
                })
              "
            >
              忘记密码
            </p>
          </div>
        </div></van-tab
      >
    </van-tabs>
    <div v-else class="zzh">
      <p class="toptitle">选择子账号</p>
      <ul class="zzhList">
        <li class="zzhItem" v-for="(item, index) in user_list" :key="index">
          <div class="left">
            <img src="../../assets/images/userImg.png" alt="" class="img" />
            <p>{{ item.uname }}</p>
          </div>
          <van-radio-group v-model="radio">
            <van-radio :name="index + 1" checked-color="#FFA624"></van-radio>
          </van-radio-group>
        </li>
      </ul>
      <div class="btn" @click="zzhLogin">登录</div>
      <div class="btn btn1" @click="addZzh">创建子账号</div>

      <!-- <div class="btn">退出</div> -->
    </div>
  </div>
</template>

<script>
import apiFun from "../../servers/apiFun";
import comTool from "../../assets/js/until";
export default {
  components: {},
  data() {
    return {
      isLogin: 0,
      active: 2,
      number: 0,
      code: "",
      timer: null,
      phone: "",
      account: "",
      password: "",
      codeBtn: "发送验证码",
      radio: 1,
      user_list: [],
    };
  },
  methods: {
    addZzh() {
      let sj = "";
      if (this.active == 2) {
        console.log(123);
        sj = this.phone;
      } else {
        console.log(456);
        sj = this.account;
      }
      console.log(sj);
      this.$router.push({
        path: "/subAccountregister",
        query: {
          phone: sj,
        },
      });
    },
    zzhLogin() {
      console.log(this.radio);
      let data = {
        gid: "100682",
        pid: "100",
        mid: "10000",
        p_mid: "1",
        device_id: "00e7efa241dae8842c8286cf69508e9c",
        client: "h5",
        client_id: "00e7efa241dae8842c8286cf69508e9c",
        tm: comTool.getTm(),
        uname: this.user_list[this.radio - 1].uname,
        access_token: this.user_list[this.radio - 1].access_token,
      };
      data.sign = comTool.querySort(data);
      apiFun.ZzhLogin(data).then((res) => {
        console.log(res.data);
        if (res.code == 200) {
          this.$cookies.set("access_token", res.data.access_token, "7d");
          this.$cookies.set("mobile", res.data.vname, "7d");
          this.$cookies.set("uname", res.data.uname, "7d");
          this.$cookies.set("uid", res.data.uid, "7d");
          this.$cookies.set("idNumber", res.data.idInfo.idNumber, "7d");
          this.$cookies.set("realName", res.data.idInfo.realName, "7d");
          this.$router.go(-1);
        } else {
          this.$toast.fail(res.msg);
        }
      });
    },
    codeLogin() {
      var reg = new RegExp("^1[3-9][0-9]{9}$");
      if (reg.test(this.phone) && this.code.length > 0) {
        let data = {
          gid: "100682",
          pid: "100",
          mid: "10000",
          p_mid: "1",
          device_id: "00e7efa241dae8842c8286cf69508e9c",
          client: "h5",
          client_id: "00e7efa241dae8842c8286cf69508e9c",
          tm: comTool.getTm(),
          mobile: this.phone,
          vcode: this.code,
        };
        data.sign = comTool.querySort(data);
        apiFun.CodeLogin(data).then((res) => {
          if (res.code == 200) {
            this.user_list = res.data.user_list;
            this.isLogin = 1;
          } else {
            this.$toast.fail(res.msg);
          }
        });
      } else {
        this.$toast.fail("请输入正确的账号密码！");
      }
    },
    change() {
      console.log(312333333333);
      this.phone = "";
      this.account = "";
      this.code = "";
    },
    accountLogin() {
      if (this.account.length > 0 && this.password.length > 0) {
        let data = {
          gid: "100682",
          pid: "100",
          mid: "10000",
          p_mid: "1",
          device_id: "00e7efa241dae8842c8286cf69508e9c",
          client: "h5",
          client_id: "00e7efa241dae8842c8286cf69508e9c",
          tm: comTool.getTm(),
          uname: this.account,
          pwd: comTool.getMd5(this.password),
        };
        data.sign = comTool.querySort(data);
        apiFun.PwdLogin(data).then((res) => {
          console.log(res.data);
          if (res.code == 200) {
            if (res.data.access_token) {
              this.$cookies.set("access_token", res.data.access_token, "7d");
              this.$cookies.set("uname", res.data.uname, "7d");
              this.$cookies.set("uid", res.data.uid, "7d");
              this.$cookies.set("idNumber", res.data.idInfo.idNumber, "7d");
              this.$cookies.set("realName", res.data.idInfo.realName, "7d");
              this.$router.go(-1);
            } else {
              this.user_list = res.data.user_list;
              this.isLogin = 1;
            }
          } else {
            this.$toast.fail(res.msg);
          }
        });
      } else {
        this.$toast.fail("请输入正确的账号密码！");
      }
    },
    sendCode() {
      var reg = new RegExp("^1[3-9][0-9]{9}$");
      if (this.number > 0) {
        this.$toast.fail("请勿频繁发送验证码！");
        return;
      } else {
        if (reg.test(this.phone)) {
          let data = {
            gid: "100682",
            pid: "100",
            mid: "10000",
            p_mid: "1",
            device_id: "00e7efa241dae8842c8286cf69508e9c",
            client: "h5",
            client_id: "00e7efa241dae8842c8286cf69508e9c",
            tm: comTool.getTm(),
            type: "quick_login",
            mobile: this.phone,
          };
          data.sign = comTool.querySort(data);
          apiFun.RegisterCode(data).then((res) => {
            if (res.code == 200) {
              this.number = 60;
              this.timer = setInterval(() => {
                this.codeBtn = this.number + "s";
                this.number--;
                if (this.number == 0) {
                  clearInterval(this.timer);
                  this.codeBtn = "发送验证码";
                  this.number = 0;
                }
              }, 1000);
              this.$toast.success(res.msg);
            } else {
              this.$toast.fail(res.msg);
            }
          });
        } else {
          this.$toast.fail("请输入正确的手机号码！");
        }
      }
    },
  },
};
</script>

<style lang="less"  scoped>
.loginContent {
  .top {
    width: 100vw;
    height: 59.7333vw;
    background-image: url("../../assets/images/loginbanner.png");
    background-size: 100vw 59.7333vw;
    background-repeat: no-repeat;
  }
  .content {
    background: #f8f8f8;
    margin-top: 6.1333vw;
    .other {
      width: 80vw;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffa624;
      margin-top: 3vw;
      font-size: 3.5vw;
      span {
        margin: 0 3vw;
      }
    }
    .btn {
      width: 80vw;
      height: 11.4667vw;
      background: #ffa624;
      border-radius: 6vw;
      font-size: 4vw;
      color: #fff;
      text-align: center;
      line-height: 11.4667vw;
      margin: 0 auto;
    }
    .srk {
      width: 80.1333vw;
      height: 11.4667vw;
      border-radius: 6vw;
      border: 0.3vw solid #d6d6d6;
      margin: 0 auto;
      margin-bottom: 5vw;
      .phone {
        width: 80.1333vw;
        height: 11.4667vw;
        display: flex;
        align-items: center;
        p {
          width: 20vw;
          text-align: center;
          color: #ffa624;
          font-size: 4vw;
        }
      }
      img {
        width: 3.4667vw;
        height: 4.4vw;
        margin-left: 4.9333vw;
        margin-right: 2.8vw;
      }
      input {
        height: 11.4667vw;
        width: 45vw;
        background: none;
        font-size: 4vw;
        color: #666666;
      }
    }
  }

  .zzh {
    .toptitle {
      color: #888;
      font-size: 4.5vw;
      margin-top: 8vw;
    }
    .zzhList {
      width: 92vw;
      margin: 0 auto;
      margin-top: 10vw;
      height: 75vw;
      overflow-y: scroll;
      .zzhItem {
        width: 73.7333vw;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #eaeaea;
        margin-top: 3vw;
        padding-bottom: 3vw;
        .left {
          display: flex;
          align-items: center;
          .img {
            width: 9.8667vw;
            height: 9.8667vw;
            margin-right: 3vw;
            border-radius: 50%;
          }
        }
      }
      :last-child {
        border-bottom: none;
      }
    }
    .btn {
      width: 80vw;
      height: 11.4667vw;
      line-height: 11.4667vw;
      background: #ffa624;
      color: #fff;
      border-radius: 6vw;
      margin: 0 auto;
      margin-top: 4vw;
      font-size: 4vw;
    }
    .btn1 {
      margin-top: 8vw;
    }
  }
  /deep/ .van-tabs__line {
    width: 20vw;
  }
  /deep/ .van-tab__text {
    color: #666666;
  }
}
</style>